export default __webpack_public_path__ + "static/1111-87943736d9d277d08895de7875bab294.gif";